import React from 'react';
import { Calculator } from 'lucide-react';
import { formatRupees } from '../../utils/issueSubscription';

const TIER_TONE = {
  retail: 'bg-teal-50 text-[#006666]',
  shni: 'bg-amber-50 text-amber-700',
  bhni: 'bg-indigo-50 text-indigo-700',
};
const TIER_LABEL = { retail: 'RII', shni: 'sHNI', bhni: 'bHNI' };

// slabs: utils/issueSubscription.js buildLotSlabs
export const LotCalculator = ({ slabs, price, board }) => (
  <section aria-labelledby="lot-calc-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <div className="flex items-center justify-between gap-2">
      <h2 id="lot-calc-heading" className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
        <Calculator className="w-4 h-4 text-[#008080]" aria-hidden="true" />
        Investment Lot Calculator
      </h2>
      {price && <span className="px-2 py-0.5 rounded-md bg-teal-50 text-[11px] font-bold text-[#006666]">Cut-off ₹{price}</span>}
    </div>
    <p className="mt-1 text-[11px] text-slate-500">Bid sizes for each investor bracket at the cap price.</p>

    {slabs.length ? (
      <div className="mt-3 overflow-x-auto scrollbar-slim">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-[10px] font-bold uppercase tracking-wider text-slate-500 border-b border-slate-100">
              <th scope="col" className="text-left py-2 pr-2">Application</th>
              <th scope="col" className="text-right py-2 px-2">Lots</th>
              <th scope="col" className="text-right py-2 px-2">Shares</th>
              <th scope="col" className="text-right py-2 pl-2">Amount</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {slabs.map((slab) => (
              <tr key={slab.key}>
                <th scope="row" className="text-left py-2 pr-2 font-semibold text-slate-700 whitespace-nowrap">
                  <span className={`inline-block mr-1.5 px-1.5 py-0.5 rounded text-[9px] font-extrabold ${TIER_TONE[slab.tier]}`}>
                    {board === 'sme' && slab.tier === 'retail' ? 'IND' : TIER_LABEL[slab.tier]}
                  </span>
                  {slab.label}
                </th>
                <td className="text-right py-2 px-2 tabular-nums text-slate-600">{slab.lots}</td>
                <td className="text-right py-2 px-2 tabular-nums text-slate-600">{slab.shares.toLocaleString('en-IN')}</td>
                <td className="text-right py-2 pl-2 tabular-nums font-bold text-slate-900">{formatRupees(slab.amount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="mt-3 rounded-xl border border-dashed border-slate-200 bg-slate-50 px-3 py-6 text-center text-xs text-slate-500">
        Lot sizes appear once the price band and market lot are announced.
      </p>
    )}
  </section>
);

export default LotCalculator;
